import React, { useEffect, useState } from 'react';
import { Typography } from 'antd';
import { routePaths } from 'router';
import { useGetManyOrders } from 'api/orders/use-get-many-orders.ts';
import { useMoveToPath } from 'shared/hooks/use-move-to-path';
import { useOrderFiltersStore } from 'shared/stores';
import { SearchFilter } from 'components/common/search-filter';
import styles from './order-search.module.scss';

export const OrdersSearch = () => {
  const [searchString, setSearchString] = useState('');
  const { setSearch } = useOrderFiltersStore();
  const { moveToPath } = useMoveToPath();

  const { data: orders, isError } = useGetManyOrders({
    limit: 10,
    isHints: true,
    search: searchString,
    isSkip: !searchString,
  });

  const [options, setOptions] = useState<{ label: React.ReactNode; value: number }[]>([]);

  useEffect(() => {
    if (orders && !isError) {
      const values = orders.data.map((order) => ({
        label: (
          <>
            <Typography.Text strong>{order.compositeId}</Typography.Text>
            <Typography.Text className={styles.hintSecondaryInfo}> {order.clientOrderNumber}</Typography.Text>
          </>
        ),
        value: order.id,
      }));
      setOptions(values);
    } else {
      setOptions([]);
    }
  }, [orders, isError]);

  const handleSelect = (value: string) => {
    moveToPath(routePaths.order, { orderId: value });
  };

  return (
    <SearchFilter
      options={options}
      setSearch={setSearch}
      setSearchString={setSearchString}
      selectHandler={handleSelect}
    />
  );
};
